module.exports = __webpack_public_path__ + "img/cases-brand-hpnk-6.259fc26a.jpg";